import { http } from '@/utils/http'

export const getOpenIdByCode = (params) => {
  return http.get('/wechat/gzh/getAccessToken', params)
}
export const getDiyUserInfo = (params) => {
  return http.get('/hb/diy/collect/tsUserByWx', params)
}
export const getBuyUserInfo = (params) => {
  return http.get('/hb/diy/collect/tsUserByWx', params)
}
export const getStoreList = () => {
  return http.get('/sys/store/listNotPage')
}
export const getDiyOrderList = (params) => {
  return http.get('/hb/diy/collect/list', params)
}
export const cancelAppointmentOrder = (orderNo) => {
  return http.get(`/hb/book/order/app/cancel/${orderNo}`)
}
export const getLatestBookOrderInfo = (params) => {
  return http.post('/hb/book/order/app/latest', params)
}
export const getBuyOrderList = (params) => {
  return http.get('/hb/book/order/app/list', params)
}
export const buyHbWakeUp = (params) => {
  return http.post('/hb/book/order/app/wakeup', params)
}
export const sendVerification = (params) => {
  return http.post('/sendVerification', params)
}
export const saveHBDiyCollect = (params) => {
  return http.post('/hb/diy/collect/save', params)
}
export const saveHBBuy = (params) => {
  return http.post('/hb/book/order/app/save', params)
}
export const captchaImage = () => {
  return http.get('/captchaImage')
}
export const getShareSignData = (params) => {
  return http.get('/wechat/gzh/getSignature', params)
}
export const saveNewspapers = (params) => {
  return http.post('/yz/newspapers/info/app/save', params)
}
export const getNewspapersList = (params) => {
  return http.get('/yz/newspapers/info/app/list', params)
}
export const newspaperWakeup = (params) => {
  return http.post('/yz/newspapers/info/app/wakeup', params)
}
export const getNewspaperDetail = (id) => {
  return http.get(`/yz/newspapers/info/app/${id}`)
}

export const getMobileByCode = (params) => {
  return http.get('/app/qywx/getUserInfo', params)
}
export const submitApplication = (params) => {
  return http.post('/app/voucher/activate/apply', params)
}
export const getApplicationList = (params) => {
  return http.post('/app/voucher/activate/query/mine/list', params)
}
export const getApplicationDetail = (id) => {
  return http.get(`/app/voucher/activate/query/apply/detail/${id}`)
}
